import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = ["onClick"]

import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineDatasetPage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineDatasetPage',
  setup(__props) {

    document.title = "Configure dataset"

    const tid = useOrganizationUnitId()
    const id = useId()
    const { useCurrentUserQuery, usePipelineDetailsQuery, useDatasetsOfOrganizationQuery, useCreateDatasetCommand, useAttachDatasetCommand } = useAdminConfigurePipelineDatasetPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const datasetId = computed(() => modelPipelineDetailsQueryV1.value?.DatasetId)
    const ownedBy = computed(() => modelPipelineDetailsQueryV1.value?.OwnedBy)
    const name = computed(() => modelPipelineDetailsQueryV1.value?.Name)

    const { runDatasetsOfOrganizationQueryV1, modelDatasetsOfOrganizationQueryV1 } = useDatasetsOfOrganizationQuery(tid)
    const datasets = computed(() => modelDatasetsOfOrganizationQueryV1.value?.Datasets)

    const { invokeCreateDatasetCommandV1, succeedCreateDatasetCommandV1 } = useCreateDatasetCommand(null, tid, userId, name)

    const { invokeAttachDatasetCommandV1, succeedAttachDatasetCommandV1 } = useAttachDatasetCommand(id, tid, userId)

    watch([succeedCreateDatasetCommandV1, succeedAttachDatasetCommandV1], (succeed) => {
        if (succeed) location.href = `/#/admin/integrations/pipelines/details/${tid}/${id}`
    })

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
        runDatasetsOfOrganizationQueryV1()
    })

    function handleCreateDatasetCommandV1() {
        invokeCreateDatasetCommandV1({
            Id: datasetId,
            Name: `Dataset for ${name.value}`,
            OwnedBy: ownedBy.value
        })
    }

    function handleAttachDatasetCommandV1(datasetId) {
        invokeAttachDatasetCommandV1({
            DatasetId: datasetId
        })
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Configure dataset", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/details/${_unref(tid)}/${_unref(id)}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        onClick: handleCreateDatasetCommandV1,
        class: "btn btn-primary"
      }, "Create a new dataset"),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _cache[5] || (_cache[5] = _createElementVNode("strong", null, "or use existing one", -1 /* CACHED */)),
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datasets.value, (d) => {
        return (_openBlock(), _createElementBlock("button", {
          onClick: ($event: any) => (handleAttachDatasetCommandV1(d.DatasetId)),
          class: "btn btn-primary"
        }, _toDisplayString(d.Name), 9 /* TEXT, PROPS */, _hoisted_7))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}
}

})